






















































































































import { Component, Vue } from "vue-property-decorator";
import { Settings } from "@/shared/core/services/configService";
import { CrudService } from "@/shared/core/services/crudService";
import { DateHelper } from "@/shared/core/helpers/dateHelper";
import store from "@/shared/core/store";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import CtaButton from "../ctaButton/ctaButton.vue";
import HomeCarouselFrame from "./HomeCarouselFrame.vue";
import IconUsers from "../icons/IconUsers.vue";

@Component({
  components: { VueSlickCarousel, CtaButton, HomeCarouselFrame, IconUsers },
})
export default class HomeClassesCarousel extends Vue {
  slides: any[] = [];

  get sliderWrapClass() {
    if (this.slides.length <= 1) return "homeClasses__sliderWrap--single";
    if (this.slides.length === 2) return "homeClasses__sliderWrap--double";
    return "";
  }

  get shouldAutoplay() {
    return this.slides.length > 2;
  }

  get carouselSettings() {
    const count = this.slides.length;
    const hasMany = this.shouldAutoplay;
    if (count <= 2) {
      return {
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: "0px",
        variableWidth: true,
        autoplay: false,
        speed: 900,
        autoplaySpeed: 5000,
        cssEase: "ease-in-out",
        draggable: false,
        swipe: false,
        touchMove: false,
      };
    }
    return {
      arrows: false,
      dots: false,
      infinite: hasMany,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      centerPadding: "0px",
      variableWidth: true,
      autoplay: hasMany,
      speed: 900,
      autoplaySpeed: 5000,
      cssEase: "ease-in-out",
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: true,
          },
        },
      ],
    };
  }

  async mounted() {
    const url = `${Settings.HostName}/api/publicactivities/list`;
    const data = await new CrudService().httpGet(url);
    if (data == null || !data.ok) {
      console.error("Crash getting classes");
      return;
    }
    this.slides = data.model || [];
    this.$emit("loaded", this.slides.length);
  }

  nextSlide() {
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.next) {
      carousel.next();
    }
    this.restartAutoplay();
  }

  prevSlide() {
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.prev) {
      carousel.prev();
    }
    this.restartAutoplay();
  }

  restartAutoplay() {
    if (!this.shouldAutoplay) return;
    const carousel = this.$refs.carousel as any;
    if (!carousel) return;
    if (carousel.pause) {
      carousel.pause();
    } else if (carousel.slickPause) {
      carousel.slickPause();
    }
    if (carousel.play) {
      carousel.play();
      return;
    }
    if (carousel.slickPlay) {
      carousel.slickPlay();
    }
  }

  getImage(name: string) {
    if (!name) {
      return store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
    }
    return store.state.settings.Uploads + "/" + name;
  }

  getCapacity(slide: any) {
    const max =
      slide.maxParticipants ||
      slide.capacity ||
      slide.maxCapacity ||
      slide.maxPlaces;
    const current =
      slide.currentParticipants ||
      slide.taken ||
      slide.booked ||
      slide.reserved;
    if (max === undefined || max === null) return "";
    if (current === undefined || current === null) return "";
    return `${current}/${max}`;
  }

  getDate(dateStr: string) {
    if (!dateStr) return "";
    const date = DateHelper.toDate(dateStr, DateHelper.systemFormat);
    if (!date) return "";
    const culture =
      localStorage.getItem(window.location.host + "_culture") || "es-ES";
    return date.toLocaleDateString(culture, {
      day: "2-digit",
      month: "short",
    });
  }

  getTime(dateStr: string) {
    if (!dateStr) return "";
    const date = DateHelper.toDate(dateStr, DateHelper.systemFormat);
    if (!date) return "";
    const culture =
      localStorage.getItem(window.location.host + "_culture") || "es-ES";
    return date.toLocaleTimeString(culture, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  }

  getDuration(slide: any) {
    if (slide.duration) return `${slide.duration} min`;
    if (!slide.start || !slide.end) return "";
    const start = DateHelper.toDate(slide.start, DateHelper.systemFormat);
    const end = DateHelper.toDate(slide.end, DateHelper.systemFormat);
    if (!start || !end) return "";
    const minutes = Math.round((end.getTime() - start.getTime()) / 60000);
    if (minutes <= 0) return "";
    return `${minutes} min`;
  }

  getInstructor(slide: any) {
    return (
      slide.instructor ||
      slide.teacher ||
      slide.trainer ||
      slide.location ||
      slide.placeName ||
      slide.room ||
      ""
    );
  }
}
